/** Brief 12, K3 - Moliya. */
export const ruB12Moliya = {
  "moliya.title": "Финансы",
  "moliya.rate": "ЦБ · 1 $ = {rate} сум",
  "moliya.pay": "Внести платёж",
  "moliya.denied": "Роль «{role}» не видит этот раздел. Если нужно, напишите владельцу агентства.",
  "moliya.home": "На главную",
  "moliya.loadError": "Сервер не ответил. Введённые данные сохранены, страницу можно безопасно перезагрузить.",
  "moliya.loadErrorTitle": "Не удалось получить данные",
  "moliya.empty.title": "Платежей пока нет",
  "moliya.empty.message": "Внесите первый платёж или отправьте клиенту ссылку Payme · Click.",
  "moliya.setupKassas": "Настроить кассы",
  "moliya.kpi.label": "Показатели финансов",
  "moliya.kpi.income": "Поступления сегодня",
  "moliya.kpi.incomeSub": "платежей: {count}",
  "moliya.kpi.debts": "Долг клиентов",
  "moliya.kpi.debtsSub": "сделок: {deals} · просрочено: {late}",
  "moliya.kpi.providers": "Туроператорам",
  "moliya.kpi.providersSub": "в течение 7 дней",
  "moliya.kpi.pending": "Ждут подтверждения",
  "moliya.kpi.pendingSub": "платежей",
  "moliya.tabs.label": "Разделы финансов",
  "moliya.tab.in": "Платежи",
  "moliya.tab.debt": "Долг клиентов",
  "moliya.tab.ops": "Туроператорам",
  "moliya.tab.kas": "Кассы",
  "moliya.more": "Ещё",
  "moliya.tab.expenses": "Расходы",
  "moliya.tab.approvals": "Очередь подтверждения",
  "moliya.tab.vendors": "Поставщики",
  "moliya.tab.links": "Ссылки на оплату",
  "moliya.addExpense": "Внести расход",
  "moliya.due.title": "Сроки оплаты туроператорам",
  "moliya.due.source": "источник: Брони · сообщения операторов",
  "moliya.due.rest": "{provider} · осталось {amount}",
  "moliya.due.full": "{provider} · {amount}",
  "moliya.due.fly": "вылет {date}",
  "moliya.due.risk": "риск отмены",
  "moliya.due.done": "Выполнено",
  "moliya.due.toast": "Задача по оплате выполнена · {name}",
  "moliya.due.today": "до конца дня",
  "moliya.due.tomorrow": "до завтра",
  "moliya.due.until": "до {date}",
  "moliya.due.late": "Просрочено · {days} дн.",
  "moliya.link.booking": "Бронь",
  "moliya.link.deal": "Сделка",
  "moliya.col.time": "Время",
  "moliya.col.clientDeal": "Клиент · сделка",
  "moliya.col.kassa": "Касса",
  "moliya.col.amount": "Сумма",
  "moliya.col.inSom": "В сумах",
  "moliya.col.status": "Статус",
  "moliya.col.fly": "Вылет",
  "moliya.col.total": "Всего",
  "moliya.col.rest": "Остаток",
  "moliya.col.due": "Срок",
  "moliya.col.provider": "Туроператор",
  "moliya.col.payable": "К оплате",
  "moliya.col.fromClient": "От клиента",
  "moliya.bookingRef": "бронь {ref}",
  "moliya.flyLine": "вылет {date}",
  "moliya.fromClientLine": "от клиента {amount}",
  "moliya.approve": "Подтвердить",
  "moliya.approved": "Платёж подтверждён · {name}",
  "moliya.reject": "Отклонить",
  "moliya.storno": "Сторно",
  "moliya.rowMenu": "Действия с платежом",
  "moliya.manualRate": "курс введён вручную",
  "moliya.sendLink": "Отправить ссылку",
  "moliya.sent": "Ссылка на оплату отправлена клиенту {name} через {channel}",
  "moliya.sentCopied": "С клиентом {name} нет переписки. Ссылка скопирована, отправьте её вручную",
  "moliya.sentNoCopy": "С клиентом {name} нет переписки. Ссылка создана, отправьте её из карточки сделки",
  "moliya.enter": "Внести",
  "moliya.enterFull": "Внести платёж",
  "moliya.restNote": "Остаток",
  "moliya.paidMark": "Оплачено",
  "moliya.paidBadge": "Оплачено",
  "moliya.opsNote": "Если оплата туроператору ушла раньше денег клиента, в кассе будет минус. Это показывает столбец «От клиента».",
  "moliya.empty.in": "Платежей нет",
  "moliya.empty.debt": "У клиентов нет долгов",
  "moliya.empty.ops": "Нет броней к оплате туроператорам",
  "moliya.empty.kas": "Касс нет",
  "moliya.branchAll": "Все",
  "moliya.kas.today": "сегодня",
  "moliya.kas.yesterday": "вчера",
  "moliya.kas.overdrawn": "Оплачено туроператору заранее",
  "moliya.kas.none": "сегодня 0",
  "moliya.prev": "Назад",
  "moliya.next": "Далее",
  "moliya.form.deal": "Сделка",
  "moliya.form.dealPlaceholder": "Выберите сделку",
  "moliya.form.hint": "Всего {total} · оплачено {paid} · остаток {rest}",
  "moliya.form.amount": "Сумма",
  "moliya.form.amountRequired": "Введите сумму",
  "moliya.form.overRemaining": "Больше остатка: {rest}",
  "moliya.form.currency": "Валюта",
  "moliya.form.kassa": "Касса",
  "moliya.form.kassaPlaceholder": "Выберите кассу",
  "moliya.form.note": "Примечание",
  "moliya.form.notePlaceholder": "Например, оплата остатка",
  "moliya.form.date": "Дата",
  "moliya.form.instalment": "К какому траншу",
  "moliya.form.noInstalment": "Без привязки к траншу",
  "moliya.form.manualRate": "Курс (сумов за 1 $)",
  "moliya.form.save": "Сохранить",
  "moliya.form.cancel": "Отмена",
  "moliya.form.saved": "Платёж внесён · {amount}",
  "moliya.form.savedPending": "Платёж внесён · {amount} · ждёт подтверждения",
  "moliya.pay.title": "Оплата туроператору",
  "moliya.pay.owed": "Осталось: {amount}",
  "moliya.pay.noKassa": "Нет кассы в {currency}. Добавьте её в настройках.",
  "moliya.pay.done": "{provider}: {amount} отмечено как оплаченное",
  "moliya.error": "Произошла ошибка",
} as const;
